import React from 'react'
import CropperTool from 'react-easy-crop'
import { CropperProps } from './Cropper.types'
import styles from './Cropper.module.scss'
import cl from 'classnames'
import { Slider } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { IMAGE_EDITOR_STORE } from 'store'
import { Button } from 'components/shared/Button'
import { IconChecked, IconClose } from 'assets'

const CropperComponent = (props: CropperProps) => {
  const {
    className,
    style,
    [IMAGE_EDITOR_STORE]: {
      selectedImageSrc,
      initialCroppedAreaPixels,
      cropValues,
      zoomLevel,
      setZoomLevel,
      onCropChange,
      onCropComplete,
      aspect,
      aspectRatio,
      shouldRenderCropTool,
      onApplyCroppingAndProceedClick,
      onImageOnFocusRemoveCroppingClick,
      isSelectedImageAspectCropApplied
    }
  } = props

  return (
    <div
      className={cl(styles.container, className)}
      style={style}
    >

      <div className={styles.cropToolContainer}>
        {shouldRenderCropTool && (
          <CropperTool
            key={JSON.stringify(initialCroppedAreaPixels)}
            image={selectedImageSrc}
            initialCroppedAreaPixels={initialCroppedAreaPixels}
            crop={cropValues}
            zoom={zoomLevel}
            aspect={aspectRatio}
            onCropChange={onCropChange}
            onCropComplete={onCropComplete}
            onZoomChange={setZoomLevel}
            minZoom={0.1}
            maxZoom={3}
            restrictPosition={false}
            classes={{
              containerClassName: styles.cropToolInner,
              cropAreaClassName: styles.cropToolCropArea
            }}
          />
        )}
        <div className={styles.overTopRightCorner}>
          <Button
            preset='icon'
            className={styles.submitButton}
            title='Apply and proceed'
            onClick={onApplyCroppingAndProceedClick}
          >
            <IconChecked />
          </Button>
          <Button
            preset='icon'
            className={styles.removeButton}
            title={`Remove ${aspect} cropping`}
            onClick={onImageOnFocusRemoveCroppingClick}
            disabled={!isSelectedImageAspectCropApplied}
          >
            <IconClose />
          </Button>
        </div>
      </div>

      <div className={styles.sliderContainer}>
        <Slider
          className={styles.slider}
          min={0.1}
          max={3}
          step={0.1}
          value={zoomLevel}
          onChange={(_, value: number) => setZoomLevel(value)}
          classes={{
            rail: styles.sliderRail
          }}
        />
      </div>
    </div>
  )
}

const Cropper = inject(
  'IMAGE_EDITOR_STORE'
)(observer(CropperComponent))
export { Cropper }
